module.exports = __webpack_public_path__ + "img/dropdownArrow.c13dc271.svg";